import React, { useEffect, useState, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
import './App.css';
import DetalleProducto from './DetalleProducto';
import ConsolaModal from './ConsolaModal';
import { RUBROS } from './rubros';

const TIENDAS_STATIC = [
    { value: '47 street', label: '47 street' },
    { value: '4stroke', label: '4stroke' },
    { value: 'Alpinestars', label: 'Alpinestars' },
    { value: 'Arredo', label: 'Arredo' },
    { value: 'Atomik', label: 'Atomik' },
    { value: 'Beauty 24', label: 'Beauty 24' },
    { value: 'Bergallo y Pastrone', label: 'Bergallo y Pastrone' },
    { value: 'Boca Shop', label: 'Boca Shop' },
    { value: 'Bowen', label: 'Bowen' },
    { value: 'Bringeri', label: 'Bringeri' },
    { value: 'Cachavacha', label: 'Cachavacha' },
    { value: 'Calle M', label: 'Calle M' },
    { value: 'Calzados Nico', label: 'Calzados Nico' },
    { value: 'Carrefour', label: 'Carrefour' },
    { value: 'Cero 26', label: 'Cero 26' },
    { value: 'Cetrogar', label: 'Cetrogar' },
    { value: 'Chelsea', label: 'Chelsea' },
    { value: 'Coppel', label: 'Coppel' },
    { value: 'Cordiez', label: 'Cordiez' },
    { value: 'Creciendo', label: 'Creciendo' },
    { value: 'Crocs', label: 'Crocs' },
    { value: 'Dash', label: 'Dash' },
    { value: 'Desiderata', label: 'Desiderata' },
    { value: 'Dexter', label: 'Dexter' },
    { value: 'Dia%', label: 'Dia%' },
    { value: 'Disco', label: 'Disco' },
    { value: 'Easy', label: 'Easy' },
    { value: 'El Balcon', label: 'El Balcon' },
    { value: 'Electrolux', label: 'Electrolux' },
    { value: 'ENA Sport', label: 'ENA Sport' },
    { value: 'Equus', label: 'Equus' },
    { value: 'Exit', label: 'Exit' },
    { value: 'Factory Deportivo', label: 'Factory Deportivo' },
    { value: 'Familia Bercomat', label: 'Familia Bercomat' },
    { value: 'Farmacity', label: 'Farmacity' },
    { value: 'Farmaonline', label: 'Farmaonline' },
    { value: 'Farmaplus', label: 'Farmaplus' },
    { value: 'Farmaquiero', label: 'Farmaquiero' },
    { value: 'Ferniplast', label: 'Ferniplast' },
    { value: 'Ferreira Sport', label: 'Ferreira Sport' },
    { value: 'Fila', label: 'Fila' },
    { value: 'Fiorani FreeShop', label: 'Fiorani FreeShop' },
    { value: 'Fravega', label: 'Fravega' },
    { value: 'Gran Bazar', label: 'Gran Bazar' },
    { value: 'Grid', label: 'Grid' },
    { value: 'Hiper Libertad', label: 'Hiper Libertad' },
    { value: 'instore', label: 'instore' },
    { value: 'JJdeportes', label: 'JJdeportes' },
    { value: 'Johnfoos', label: 'Johnfoos' },
    { value: 'Juleriaque', label: 'Juleriaque' },
    { value: 'Jumbo', label: 'Jumbo' },
    { value: 'Kappa', label: 'Kappa' },
    { value: 'Kinderland', label: 'Kinderland' },
    { value: 'La Cardeuse', label: 'La Cardeuse' },
    { value: 'Levis', label: 'Levis' },
    { value: 'Luigibosca', label: 'Luigibosca' },
    { value: 'Marathon', label: 'Marathon' },
    { value: 'Marea', label: 'Marea' },
    { value: 'MasOnline', label: 'MasOnline' },
    { value: 'Mimo & Co', label: 'Mimo & Co' },
    { value: 'Moov', label: 'Moov' },
    { value: 'Morph', label: 'Morph' },
    { value: 'Motorola', label: 'Motorola' },
    { value: 'Moulinex', label: 'Moulinex' },
    { value: 'Musimundo', label: 'Musimundo' },
    { value: 'Naldo', label: 'Naldo' },
    { value: 'Natural Life', label: 'Natural Life' },
    { value: 'NBA', label: 'NBA' },
    { value: 'NewSport', label: 'NewSport' },
    { value: 'OnCity', label: 'OnCity' },
    { value: 'OnSports', label: 'OnSports' },
    { value: 'Osito Azul', label: 'Osito Azul' },
    { value: 'Oster', label: 'Oster' },
    { value: 'Pandora', label: 'Pandora' },
    { value: 'Parfumerie', label: 'Parfumerie' },
    { value: 'Perfumeria Pigmento', label: 'Perfumeria Pigmento' },
    { value: 'Perfumeria Rouge', label: 'Perfumeria Rouge' },
    { value: 'Pinturerias Garin', label: 'Pinturerias Garin' },
    { value: 'Pinturerias Universo', label: 'Pinturerias Universo' },
    { value: 'Portsaid', label: 'Portsaid' },
    { value: 'PuntoDeportivo', label: 'PuntoDeportivo' },
    { value: 'Puppis', label: 'Puppis' },
    { value: 'Rapsodia', label: 'Rapsodia' },
    { value: 'Reebok', label: 'Reebok' },
    { value: 'Ricky Sarkany', label: 'Ricky Sarkany' },
    { value: 'Rossetti', label: 'Rossetti' },
    { value: 'Rougemaison', label: 'Rougemaison' },
    { value: 'Salomon', label: 'Salomon' },
    { value: 'Samsung', label: 'Samsung' },
    { value: 'Scandinavian', label: 'Scandinavian' },
    { value: 'SevenSport', label: 'SevenSport' },
    { value: 'Shipin', label: 'Shipin' },
    { value: 'Simmons', label: 'Simmons' },
    { value: 'SmartLife', label: 'SmartLife' },
    { value: 'Sony', label: 'Sony' },
    { value: 'Sporting', label: 'Sporting' },
    { value: 'Sportline', label: 'Sportline' },
    { value: 'Sportotal', label: 'Sportotal' },
    { value: 'Stanley', label: 'Stanley' },
    { value: 'Star Nutrition', label: 'Star Nutrition' },
    { value: 'Stock Center', label: 'Stock Center' },
    { value: 'Taverniti', label: 'Taverniti' },
    { value: 'Templo del Futbol', label: 'Templo del Futbol' },
    { value: 'Tienda CocaCola', label: 'Tienda CocaCola' },
    { value: 'Tienda Fuencarral', label: 'Tienda Fuencarral' },
    { value: 'Tienda River', label: 'Tienda River' },
    { value: 'Tienda Tate', label: 'Tienda Tate' },
    { value: 'Tommy Hilfiger', label: 'Tommy Hilfiger' },
    { value: 'Topper', label: 'Topper' },
    { value: 'Under Armour', label: 'Under Armour' },
    { value: 'Vea', label: 'Vea' },
    { value: 'Vinos y Spirits', label: 'Vinos y Spirits' },
    { value: 'Whirlpool', label: 'Whirlpool' },
    { value: 'Woker BySporting', label: 'Woker BySporting' },
    { value: 'XL Shop', label: 'XL Shop' },
    { value: 'Yelmo', label: 'Yelmo' }
];

axios.defaults.headers.common['ngrok-skip-browser-warning'] = 'true';

const API_BASE_URL = process.env.REACT_APP_API_URL || (
    (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
        ? `${window.location.protocol}//${window.location.hostname}:3001/api`
        : 'https://dribble-childless-explicit.ngrok-free.dev/api'
);

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

function App() {
    const [productos, setProductos] = useState([]);
    const [page, setPage] = useState(1);
    const [tiendasSeleccionadas, setTiendasSeleccionadas] = useState([]);
    const [tiendasDisponibles, setTiendasDisponibles] = useState(TIENDAS_STATIC);
    const [rubroActivo, setRubroActivo] = useState('Todos');
    const [ordenSeleccionado, setOrdenSeleccionado] = useState('reciente');
    const [soloPromos, setSoloPromos] = useState(false);
    const [soloDescuento, setSoloDescuento] = useState(false);
    const [mostrarInactivos, setMostrarInactivos] = useState(false);
    const [soloMinimoHistorico, setSoloMinimoHistorico] = useState(false);
    const [soloBugs, setSoloBugs] = useState(false);
    const [busqueda, setBusqueda] = useState('');
    const [debouncedBusqueda, setDebouncedBusqueda] = useState('');
    const [debouncedHorasCambio, setDebouncedHorasCambio] = useState('');
    const [talleBusqueda, setTalleBusqueda] = useState('');
    const [debouncedTalle, setDebouncedTalle] = useState('');
    const [tooltipVisible, setTooltipVisible] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
    const [ultimaEjecucion, setUltimaEjecucion] = useState(null);
    const [cargando, setCargando] = useState(false);
    const [errorApi, setErrorApi] = useState(null);
    const [horasCambio, setHorasCambio] = useState('');
    const [precioMin, setPrecioMin] = useState('');
    const [precioMax, setPrecioMax] = useState('');
    const [viewMode, setViewMode] = useState('grid');
    const [refrescandoShopify, setRefrescandoShopify] = useState(false);
    const [refrescandoDabra, setRefrescandoDabra] = useState(false);
    const [toastCopiado, setToastCopiado] = useState(null);
    const [productoSeleccionado, setProductoSeleccionado] = useState(null);

    // Nuevos Estados V5
    const [darkMode, setDarkMode] = useState(() => {
        try {
            return localStorage.getItem('theme_dark') === 'true';
        } catch (e) {
            return false;
        }
    });
    const [alertasActivas, setAlertasActivas] = useState(() => {
        try {
            return localStorage.getItem('vtex_alertas_activas') === 'true';
        } catch (e) {
            return false;
        }
    });
    const [minDescuentoAlerta, setMinDescuentoAlerta] = useState(() => {
        try {
            const guardado = localStorage.getItem('vtex_min_descuento_alerta');
            return guardado ? parseInt(guardado, 10) : 20; // 20% por defecto
        } catch (e) {
            return 20;
        }
    });

    const cambiarMinDescuentoAlerta = (nuevo) => {
        const val = Number(nuevo);
        setMinDescuentoAlerta(val);
        try {
            localStorage.setItem('vtex_min_descuento_alerta', String(val));
        } catch (e) {}
        registrarWebPush(val);
        setToastCopiado(`alerta_pct_${val}`);
        setTimeout(() => setToastCopiado(null), 3000);
    };
    const [stats, setStats] = useState(null);
    const [mostrarRadar, setMostrarRadar] = useState(true);
    const [comparandoProducto, setComparandoProducto] = useState(null);
    const [comparacionesModal, setComparacionesModal] = useState([]);
    const [cargandoComparaciones, setCargandoComparaciones] = useState(false);
    const [mostrarConsola, setMostrarConsola] = useState(false);

    const [alertaFlotante, setAlertaFlotante] = useState(null);
    const skusNotificados = useRef(new Set());

    // Guardar preferencia de Dark Mode
    
    // Cargar lista completa de tiendas en vivo desde la base de datos
    useEffect(() => {
        fetch(`${API_BASE_URL}/tiendas`)
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data) && data.length > 0) {
                    const opciones = data.map(nombre => ({ value: nombre, label: nombre }));
                    setTiendasDisponibles(opciones);
                }
            })
            .catch(() => {});
    }, []);

    useEffect(() => {
        try {
            localStorage.setItem('theme_dark', darkMode);
        } catch (e) {}
    }, [darkMode]);

    // Sonido de alerta Web Audio API (Universal)
    const playSoundAlert = () => {
        try {
            const AudioCtx = window.AudioContext || window.webkitAudioContext;
            if (!AudioCtx) return;
            const ctx = new AudioCtx();
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.type = 'sine';
            osc.frequency.setValueAtTime(587.33, ctx.currentTime);
            osc.frequency.exponentialRampToValueAtTime(880, ctx.currentTime + 0.15);
            gain.gain.setValueAtTime(0.2, ctx.currentTime);
            gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.35);
            osc.connect(gain);
            gain.connect(ctx.destination);
            osc.start();
            osc.stop(ctx.currentTime + 0.35);
        } catch (e) {}
    };

    // Registrar o actualizar suscripción Web Push en el backend para notificaciones en segundo plano
    const registrarWebPush = async (minDesc) => {
        try {
            if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
                return;
            }
            if (!('Notification' in window) || Notification.permission !== 'granted') {
                return;
            }

            const reg = await navigator.serviceWorker.ready;
            if (!reg || !reg.pushManager) return;

            const resKey = await axios.get(`${API_BASE_URL}/push/vapid-public-key`);
            const publicKey = resKey.data?.publicKey;
            if (!publicKey) return;

            let sub = await reg.pushManager.getSubscription();
            if (!sub) {
                sub = await reg.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: urlBase64ToUint8Array(publicKey)
                });
            }

            const subJson = sub.toJSON();
            await axios.post(`${API_BASE_URL}/push/subscribe`, {
                subscription: subJson,
                minDescuento: minDesc !== undefined ? minDesc : minDescuentoAlerta
            });
            console.log('✅ Web Push registrado en el servidor (descuento >= ' + (minDesc !== undefined ? minDesc : minDescuentoAlerta) + '%)');
        } catch (err) {
            console.warn('Registro Web Push:', err.message);
        }
    };

    // Sincronizar Web Push al iniciar si ya tiene permisos concedidos
    useEffect(() => {
        if ('Notification' in window && Notification.permission === 'granted') {
            registrarWebPush(minDescuentoAlerta);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Función universal para mostrar notificaciones nativas (Compatible con Android Chrome y Desktop)
    const mostrarNotificacionNativa = async (titulo, opciones = {}) => {
        try {
            if (!('Notification' in window)) return;
            if (Notification.permission !== 'granted') return;

            // En Android Chrome es obligatorio usar ServiceWorkerRegistration.showNotification()
            if ('serviceWorker' in navigator) {
                try {
                    const reg = await navigator.serviceWorker.ready;
                    if (reg && reg.showNotification) {
                        await reg.showNotification(titulo, {
                            ...opciones,
                            icon: opciones.icon || '/logo192.png',
                            badge: opciones.badge || '/logo192.png',
                            vibrate: opciones.vibrate || [300, 150, 300]
                        });
                        return;
                    }
                } catch (swErr) {
                    console.warn('SW notification fallback:', swErr);
                }
            }

            // Fallback para Desktop Chrome
            const notif = new Notification(titulo, opciones);
            notif.onclick = () => {
                window.focus();
                notif.close();
            };
        } catch (e) {
            console.warn('Error al disparar notificación:', e);
        }
    };

    // Disparar Alerta Integral (Sonido + Banner en Pantalla + Parpadeo de Pestaña + Notificación Nativa)
    const dispararAlerta = (b) => {
        playSoundAlert();
        setAlertaFlotante(b);
        setTimeout(() => setAlertaFlotante(null), 12000);

        // Titilar título de la pestaña del navegador
        const originalTitle = '📊 Monitor de Ofertas y Precios';
        let count = 0;
        const interval = setInterval(() => {
            document.title = (count % 2 === 0) ? `🔥 ¡OFERTA EN ${b.tienda}! - ${formatearMoneda(b.price)}` : originalTitle;
            count++;
            if (count >= 12) {
                clearInterval(interval);
                document.title = originalTitle;
            }
        }, 1000);

        // Notificación nativa en Android / Windows con porcentaje y talles
        const descPct = Math.round(b.descuento || 0);
        const precioAnt = b.UltPrecio || b.priceSinDescuento;
        const iconTalle = /remera|buzo|campera|short|pantalon|calza|musculosa|conjunto|vestido/i.test(b.nombre || '') ? '👕' : '👟';
        
        let tallesTexto = '';
        if (Array.isArray(b.talles) && b.talles.length > 0) {
            tallesTexto = `\n${iconTalle} Talles: ${b.talles.slice(0, 5).join(', ')}${b.talles.length > 5 ? '...' : ''}`;
        } else if (typeof b.talles === 'string' && b.talles.trim()) {
            tallesTexto = `\n${iconTalle} Talles: ${b.talles}`;
        }

        const tituloNotif = descPct > 0 
            ? `🔥 -${descPct}% OFF en ${b.tienda}` 
            : `🔥 ¡Oferta en ${b.tienda}!`;

        const cuerpoNotif = `${b.nombre}\n💰 ${formatearMoneda(b.price)}${precioAnt ? ` (Antes: ${formatearMoneda(precioAnt)})` : ''}${tallesTexto}`;

        mostrarNotificacionNativa(tituloNotif, {
            body: cuerpoNotif,
            icon: b.imagenUrl || '/logo192.png',
            badge: '/logo192.png',
            vibrate: [300, 150, 300, 150, 300],
            data: { url: b.url || window.location.href }
        });
    };

    // Botón para probar notificación inmediatamente en el celular o PC
    const enviarPruebaNotificacion = async () => {
        playSoundAlert();
        try {
            if ('Notification' in window) {
                let perm = Notification.permission;
                if (perm !== 'granted') {
                    perm = await Notification.requestPermission();
                }
                if (perm === 'granted') {
                    // Notificación local inmediata
                    await mostrarNotificacionNativa('🔥 -70% OFF en Moov', {
                        body: 'Zapatillas Puma Suede Classic XXI\n💰 $44.999 (Antes: $149.999)\n👟 Talles: 39, 40, 41, 42\n✅ Notificaciones activas.',
                        icon: '/logo192.png',
                        badge: '/logo192.png',
                        vibrate: [300, 150, 300, 150, 300],
                        data: { url: window.location.href }
                    });

                    // Registrar suscripción en el backend
                    await registrarWebPush(minDescuentoAlerta);

                    // Disparar prueba de Web Push del servidor
                    try {
                        await axios.post(`${API_BASE_URL}/push/test`);
                    } catch (pushErr) {
                        console.warn('Backend push test:', pushErr.message);
                    }

                    setToastCopiado('prueba_enviada');
                    setTimeout(() => setToastCopiado(null), 4000);
                } else {
                    alert('Debes permitir las notificaciones en el navegador para recibir alertas.');
                }
            } else {
                alert('Tu navegador no soporta notificaciones nativas.');
            }
        } catch (err) {
            console.error('Error prueba notif:', err);
        }
    };

    // Activar / Desactivar alertas (Funciona en Chrome, HTTPS, PC y Celular)
    const toggleAlertas = async () => {
        const nuevoEstado = !alertasActivas;
        setAlertasActivas(nuevoEstado);
        try {
            localStorage.setItem('vtex_alertas_activas', String(nuevoEstado));
        } catch (e) {}

        if (nuevoEstado) {
            playSoundAlert();

            // Solicitar permisos de notificación nativa de Chrome / Android / Windows y registrar Web Push
            try {
                if ('Notification' in window) {
                    const perm = await Notification.requestPermission();
                    if (perm === 'granted') {
                        await mostrarNotificacionNativa('🔔 Alertas de Chrome activadas', {
                            body: 'Te avisaremos con sonido y notificación en pantalla ante nuevas ofertas.',
                            icon: '/logo192.png',
                            vibrate: [200, 100, 200]
                        });
                        await registrarWebPush(minDescuentoAlerta);
                    }
                }
            } catch (e) {}

            setToastCopiado('alertas_activadas');
            setTimeout(() => setToastCopiado(null), 3500);
        } else {
            setAlertaFlotante(null);
        }
    };

    // Polling de alertas cada 25 segundos si están activas
    useEffect(() => {
        if (!alertasActivas) return;

        // Polling de alertas cada 20 segundos para nuevas ofertas con el % configurado
        let inicial = true;
        const checkBugs = () => {
            axios.get(`${API_BASE_URL}/productos?limit=15&tieneDescuento=si&minDescuento=${minDescuentoAlerta}&orden=reciente`)
                .then(res => {
                    const ofertas = res.data || [];
                    if (inicial && skusNotificados.current.size === 0) {
                        ofertas.forEach(b => skusNotificados.current.add(b._id || b.sku));
                        inicial = false;
                        return;
                    }
                    inicial = false;

                    for (const b of ofertas) {
                        const id = b._id || b.sku;
                        const desc = b.descuento || 0;
                        if (desc >= minDescuentoAlerta || b.posibleBug) {
                            if (!skusNotificados.current.has(id)) {
                                skusNotificados.current.add(id);
                                dispararAlerta(b);
                            }
                        }
                    }
                })
                .catch(() => {});
        };

        checkBugs();
        const interval = setInterval(checkBugs, 20000);
        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [alertasActivas, minDescuentoAlerta]);

    // Cargar estadísticas globales
    useEffect(() => {
        const cargarStats = () => {
            axios.get(`${API_BASE_URL}/stats`)
                .then(res => {
                    if (res.data) setStats(res.data);
                })
                .catch(() => {});
        };
        cargarStats();
        const timer = setInterval(cargarStats, 90000);
        return () => clearInterval(timer);
    }, []);

    // Cargar detalle por URL param
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const prodId = params.get('producto');
        if (prodId) {
            axios.get(`${API_BASE_URL}/producto/${prodId}`)
                .then(res => {
                    if (res.data) setProductoSeleccionado(res.data);
                })
                .catch(() => {});
        }

        const handlePopState = () => {
            const p = new URLSearchParams(window.location.search);
            const id = p.get('producto');
            if (!id) {
                setProductoSeleccionado(null);
            }
        };
        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, []);

    const abrirDetalle = (prod) => {
        setProductoSeleccionado(prod);
        const url = new URL(window.location);
        url.searchParams.set('producto', prod._id || prod.sku);
        window.history.pushState({}, '', url);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const volverAlCatalogo = () => {
        setProductoSeleccionado(null);
        const url = new URL(window.location);
        url.searchParams.delete('producto');
        window.history.pushState({}, '', url);
    };

    // Modal de comparación rápida
    const abrirComparacionModal = (e, prod) => {
        e.stopPropagation();
        setComparandoProducto(prod);
        setComparacionesModal([]);
        setCargandoComparaciones(true);

        axios.get(`${API_BASE_URL}/producto/${prod._id || prod.sku}/comparaciones`)
            .then(res => {
                setComparacionesModal(res.data?.comparaciones || []);
            })
            .catch(err => {
                console.error("Error buscando comparaciones:", err);
                setComparacionesModal([]);
            })
            .finally(() => setCargandoComparaciones(false));
    };

    const cerrarComparacionModal = () => {
        setComparandoProducto(null);
        setComparacionesModal([]);
    };

    // Exportar a Excel (CSV con UTF-8 BOM)
    const exportarCSV = () => {
        if (!productos || productos.length === 0) {
            alert('No hay productos en pantalla para exportar.');
            return;
        }

        const headers = ['Tienda', 'Nombre', 'Precio Actual', 'Precio Anterior', 'Descuento %', 'Minimo Historico', 'Posible Bug', 'Enlace'];
        const rows = productos.map(p => [
            `"${(p.tienda || '').replace(/"/g, '""')}"`,
            `"${(p.nombre || '').replace(/"/g, '""')}"`,
            p.price || 0,
            p.UltPrecio || '',
            p.descuento || 0,
            p.esMinimoHistorico ? 'SI' : 'NO',
            p.posibleBug ? 'SI' : 'NO',
            `"${(p.url || '').replace(/"/g, '""')}"`
        ]);

        const csvContent = '\uFEFF' + [headers.join(';'), ...rows.map(r => r.join(';'))].join('\r\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', `ofertas_vtex_${new Date().toISOString().slice(0, 10)}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Selección de Rubro
    const handleSelectRubro = (rubro) => {
        setRubroActivo(rubro);
        if (rubro === 'Todos') {
            setTiendasSeleccionadas([]);
        } else {
            const tiendasDelRubro = RUBROS[rubro] || [];
            const seleccion = tiendasDisponibles.filter(t => tiendasDelRubro.includes(t.value));
            setTiendasSeleccionadas(seleccion);
        }
        setPage(1);
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const date = new Date(fecha);
        return date.toLocaleDateString('es-AR', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    };

    const formatearMoneda = (value) => {
        return new Intl.NumberFormat('es-AR', {
            style: 'currency', currency: 'ARS',
            minimumFractionDigits: 0, maximumFractionDigits: 0
        }).format(value);
    };

    const calcularCambioPrecio = (precioActual, precioAnterior) => {
        if (!precioAnterior || precioAnterior <= 0) return { tipo: 'sin_cambio', porcentaje: 0 };
        const diferencia = precioActual - precioAnterior;
        const porcentaje = Math.abs(Math.round((diferencia / precioAnterior) * 100));
        if (diferencia < 0) return { tipo: 'descuento', porcentaje };
        if (diferencia > 0) return { tipo: 'aumento', porcentaje };
        return { tipo: 'sin_cambio', porcentaje: 0 };
    };

    const manejarMouseEnter = (index, event) => {
        setTooltipVisible(index);
        setTooltipPosition({ x: event.clientX + 10, y: event.clientY + 10 });
    };

    const manejarMouseLeave = () => setTooltipVisible(null);

    const manejarMouseMove = (event) => {
        if (tooltipVisible !== null) {
            setTooltipPosition({ x: event.clientX + 10, y: event.clientY + 10 });
        }
    };

    useEffect(() => {
        axios.get(`${API_BASE_URL}/uptime`)
            .then(res => setUltimaEjecucion(res.data.fecha))
            .catch(err => console.error("Error fetching uptime:", err));
    }, []);

    useEffect(() => {
        const timerId = setTimeout(() => setDebouncedBusqueda(busqueda), 500);
        return () => clearTimeout(timerId);
    }, [busqueda]);

    useEffect(() => {
        const timerId = setTimeout(() => setDebouncedHorasCambio(horasCambio), 400);
        return () => clearTimeout(timerId);
    }, [horasCambio]);

    useEffect(() => {
        const timerId = setTimeout(() => setDebouncedTalle(talleBusqueda), 400);
        return () => clearTimeout(timerId);
    }, [talleBusqueda]);

    useEffect(() => {
        const controller = new AbortController();
        let isCurrent = true;

        const tiendasQuery = tiendasSeleccionadas.map(t => t.value).join(',');
        const url = `${API_BASE_URL}/productos?page=${page}` +
            `&limit=100` +
            (tiendasQuery ? `&tienda=${tiendasQuery}` : '') +
            (ordenSeleccionado ? `&orden=${ordenSeleccionado}` : '') +
            (soloPromos ? `&soloPromos=true` : '') +
            (soloDescuento ? `&tieneDescuento=si` : '') +
            (mostrarInactivos ? `&mostrarInactivos=true` : '') +
            (soloMinimoHistorico ? `&soloMinimoHistorico=true` : '') +
            (soloBugs ? `&soloBugs=true` : '') +
            (debouncedBusqueda ? `&search=${encodeURIComponent(debouncedBusqueda)}` : '') +
            (debouncedHorasCambio && !isNaN(parseInt(debouncedHorasCambio)) && parseInt(debouncedHorasCambio) > 0 ? `&lastHours=${parseInt(debouncedHorasCambio)}` : '') +
            (debouncedTalle ? `&talle=${encodeURIComponent(debouncedTalle.trim())}` : '') +
            (precioMin ? `&precioMin=${precioMin}` : '') +
            (precioMax ? `&precioMax=${precioMax}` : '');

        setCargando(true);
        axios.get(url, { signal: controller.signal })
            .then(res => {
                if (!isCurrent) return;
                setProductos(res.data);
                setErrorApi(null);
            })
            .catch(err => {
                if (axios.isCancel(err) || err.code === 'ERR_CANCELED' || !isCurrent) {
                    // Petición anterior cancelada para dar prioridad a la búsqueda o filtro actual
                    return;
                }
                console.error("Error fetching products:", err);
                setErrorApi('Error al cargar productos. Por favor, intente más tarde.');
                setProductos([]);
            })
            .finally(() => {
                if (isCurrent) setCargando(false);
            });

        return () => {
            isCurrent = false;
            controller.abort();
        };
    }, [page, tiendasSeleccionadas, ordenSeleccionado, soloPromos, soloDescuento, mostrarInactivos, soloMinimoHistorico, soloBugs, debouncedBusqueda, debouncedHorasCambio, debouncedTalle, precioMin, precioMax]);

    const handleRefreshShopify = () => {
        setRefrescandoShopify(true);
        axios.post(`${API_BASE_URL}/shopify/refresh`)
            .then(() => {
                setTimeout(() => {
                    setPage(1);
                    setRefrescandoShopify(false);
                }, 5000);
            })
            .catch(err => {
                console.error("Error refrescando Shopify:", err);
                setRefrescandoShopify(false);
            });
    };

    const handleRefreshDabra = () => {
        setRefrescandoDabra(true);
        axios.post(`${API_BASE_URL}/dabra/refresh`)
            .then(() => {
                setTimeout(() => {
                    setPage(1);
                    setRefrescandoDabra(false);
                }, 4000);
            })
            .catch(err => {
                console.error("Error refrescando Dabra:", err);
                setRefrescandoDabra(false);
            });
    };

    const handleCopiarOferta = (e, prod) => {
        e.stopPropagation();

        // 1. Calcular porcentaje de descuento real
        let descPct = prod.descuento;
        if (!descPct || isNaN(descPct)) {
            const precioRef = prod.UltPrecio || prod.priceSinDescuento;
            if (precioRef && precioRef > prod.price && prod.price > 0) {
                descPct = Math.round(((precioRef - prod.price) / precioRef) * 100);
            } else {
                descPct = 0;
            }
        }
        const descHeader = descPct > 0 ? ` (-${descPct}% OFF)` : '';

        // 2. Talles disponibles
        const iconTalle = /remera|buzo|campera|short|pantalon|calza|musculosa|conjunto|vestido/i.test(prod.nombre || '') ? '👕' : '👟';
        const tallesTexto = prod.talles && prod.talles.length > 0 
            ? `${iconTalle} Talles disponibles: ${prod.talles.join(', ')}\n` 
            : '';

        // 3. Promociones disponibles
        let promosTexto = '';
        if (Array.isArray(prod.promotions) && prod.promotions.length > 0) {
            const listaPromos = prod.promotions
                .map(p => typeof p === 'string' ? p : (p.name || ''))
                .filter(Boolean);
            if (listaPromos.length > 0) {
                promosTexto = `🎁 Promos: ${listaPromos.join(' | ')}\n`;
            }
        } else if (typeof prod.promotions === 'string' && prod.promotions.trim()) {
            promosTexto = `🎁 Promos: ${prod.promotions.trim()}\n`;
        }

        const precioAnt = prod.UltPrecio || prod.priceSinDescuento;
        const antesTexto = precioAnt > prod.price ? ` (Antes: ${formatearMoneda(precioAnt)})` : '';

        const texto = `🔥 ¡OFERTA IMPERDIBLE!${descHeader}\n` +
            `📦 ${prod.nombre}\n` +
            `💰 Precio: ${formatearMoneda(prod.price)}${antesTexto}${descPct > 0 ? ` [${descPct}% OFF]` : ''}\n` +
            tallesTexto +
            promosTexto +
            `🛍️ Tienda: ${prod.tienda}\n` +
            `🔗 Ver producto: ${prod.url}`;

        const copiarTexto = () => {
            if (navigator.clipboard && window.isSecureContext) {
                return navigator.clipboard.writeText(texto);
            }
            return new Promise((resolve, reject) => {
                try {
                    const textArea = document.createElement("textarea");
                    textArea.value = texto;
                    textArea.style.position = "fixed";
                    textArea.style.left = "-999999px";
                    textArea.style.top = "-999999px";
                    textArea.setAttribute("readonly", "");
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    const exito = document.execCommand('copy');
                    document.body.removeChild(textArea);
                    if (exito) resolve();
                    else reject(new Error("Falló execCommand copy"));
                } catch (err) {
                    reject(err);
                }
            });
        };

        copiarTexto()
            .then(() => {
                setToastCopiado(prod._id || prod.sku);
                setTimeout(() => setToastCopiado(null), 2500);
            })
            .catch(() => {
                window.prompt('Copia el enlace de la oferta:', texto);
            });
    };

    const handleClearFilters = () => {
        setTiendasSeleccionadas([]);
        setRubroActivo('Todos');
        setOrdenSeleccionado('reciente');
        setSoloPromos(false);
        setSoloDescuento(false);
        setMostrarInactivos(false);
        setSoloMinimoHistorico(false);
        setSoloBugs(false);
        setBusqueda('');
        setTalleBusqueda('');
        setHorasCambio('');
        setPrecioMin('');
        setPrecioMax('');
        setPage(1);
    };

    if (productoSeleccionado) {
        return (
            <div className={`app ${darkMode ? 'dark-mode' : ''}`}>
                <DetalleProducto 
                    producto={productoSeleccionado} 
                    alVolver={volverAlCatalogo} 
                />
            </div>
        );
    }

    return (
        <div className={`app ${darkMode ? 'dark-mode' : ''}`}>
            {typeof toastCopiado === 'string' && toastCopiado.startsWith('alerta_pct_') ? (
                <div className="toast-copiado-flotante" style={{ backgroundColor: '#0969da' }}>
                    🎯 Filtro de alertas actualizado: avisando desde {toastCopiado.replace('alerta_pct_', '')}% OFF
                </div>
            ) : toastCopiado === 'prueba_enviada' ? (
                <div className="toast-copiado-flotante" style={{ backgroundColor: '#2da44e' }}>
                    📲 ¡Notificación de prueba enviada a tu dispositivo!
                </div>
            ) : toastCopiado === 'alertas_activadas' ? (
                <div className="toast-copiado-flotante" style={{ backgroundColor: '#0969da' }}>
                    🔔 ¡Alertas activadas! Te avisará con sonido y aviso emergente ante cada ganga.
                </div>
            ) : toastCopiado ? (
                <div className="toast-copiado-flotante">
                    ✅ ¡Detalles de la oferta copiados al portapapeles!
                </div>
            ) : null}

            {/* Banner Flotante Emergente de Bug en Vivo */}
            {alertaFlotante && (
                <div 
                    className="alerta-banner-emergente" 
                    onClick={() => { abrirDetalle(alertaFlotante); setAlertaFlotante(null); }}
                    title="Hacer clic para ver el producto en detalle"
                >
                    <div className="alerta-banner-icono">🔥</div>
                    <div className="alerta-banner-info">
                        <strong>
                            🔥 {alertaFlotante.descuento ? `-${Math.round(alertaFlotante.descuento)}% OFF en ${alertaFlotante.tienda}` : `¡Oferta en ${alertaFlotante.tienda}!`}
                        </strong>
                        <span>
                            {alertaFlotante.nombre} — <span style={{ color: '#16a34a', fontWeight: 'bold' }}>{formatearMoneda(alertaFlotante.price)}</span>
                            {alertaFlotante.talles && alertaFlotante.talles.length > 0 && (
                                <span style={{ marginLeft: '6px', fontSize: '12px', opacity: 0.85 }}>
                                    (Talles: {alertaFlotante.talles.slice(0, 4).join(', ')}{alertaFlotante.talles.length > 4 ? '...' : ''})
                                </span>
                            )}
                        </span>
                    </div>
                    <button 
                        type="button"
                        className="btn-ver-alerta" 
                        onClick={(e) => { e.stopPropagation(); abrirDetalle(alertaFlotante); setAlertaFlotante(null); }}
                    >
                        VER AHORA 👁️
                    </button>
                    <button 
                        type="button"
                        className="btn-cerrar-alerta" 
                        onClick={(e) => { e.stopPropagation(); setAlertaFlotante(null); }}
                    >
                        ✕
                    </button>
                </div>
            )}

            {/* --- HEADER PRINCIPAL CON CONTROLES V5 --- */}
            <div className="header-top">
                <h1>📊 Monitor de Ofertas y Precios</h1>
                <div className="header-controles">
                    <button 
                        type="button" 
                        onClick={() => setMostrarConsola(true)} 
                        className="btn-header-control btn-consola-header"
                        title="Abrir simulación interactiva de la consola / terminal del bot"
                        style={{ 
                            backgroundColor: '#0d1117', 
                            color: '#3fb950', 
                            border: '1px solid #30363d', 
                            fontWeight: '700',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}
                    >
                        <span style={{ color: '#58a6ff' }}>⚡</span> 🖥️ Consola en Vivo
                    </button>
                    <button 
                        type="button" 
                        onClick={exportarCSV} 
                        className="btn-header-control"
                        title="Descargar las ofertas actuales a Excel / CSV"
                    >
                        📥 Exportar CSV
                    </button>
                    <button 
                        type="button" 
                        onClick={toggleAlertas} 
                        className={`btn-header-control ${alertasActivas ? 'activo' : ''}`}
                        title="Activar avisos sonoros y notificaciones de escritorio ante nuevos bugs"
                    >
                        {alertasActivas ? '🔔 Alertas Activas' : '🔕 Activar Alertas'}
                    </button>
                    <div 
                        className="control-alerta-porcentaje" 
                        title="Configurar porcentaje mínimo de rebaja para recibir alertas"
                    >
                        <span>🔔 Desde:</span>
                        <select 
                            value={minDescuentoAlerta} 
                            onChange={(e) => cambiarMinDescuentoAlerta(e.target.value)}
                        >
                            <option value={10}>≥ 10% OFF</option>
                            <option value={15}>≥ 15% OFF</option>
                            <option value={20}>≥ 20% OFF</option>
                            <option value={25}>≥ 25% OFF</option>
                            <option value={30}>≥ 30% OFF</option>
                            <option value={35}>≥ 35% OFF</option>
                            <option value={40}>≥ 40% OFF</option>
                            <option value={50}>≥ 50% OFF</option>
                            <option value={60}>≥ 60% OFF</option>
                            <option value={70}>🔥 Bugs (≥ 70%)</option>
                        </select>
                    </div>
                    <button 
                        type="button" 
                        onClick={enviarPruebaNotificacion} 
                        className="btn-header-control"
                        title="Enviar una notificación de prueba ahora mismo a tu celular o PC"
                        style={{ borderColor: '#ff7b72', color: '#ff7b72' }}
                    >
                        📲 Probar Notificación
                    </button>
                    <button 
                        type="button" 
                        onClick={() => setDarkMode(!darkMode)} 
                        className="btn-header-control"
                        title="Alternar entre modo claro y modo oscuro"
                    >
                        {darkMode ? '☀️ Modo Claro' : '🌙 Modo Oscuro'}
                    </button>
                </div>
            </div>

            {/* --- BARRA DE ESTADÍSTICAS GLOBALES --- */}
            <div className="stats-bar">
                <div className="stat-item">
                    <span className="stat-valor">📦 {stats?.totalProductos ? stats.totalProductos.toLocaleString('es-AR') : '1.068.500+'}</span>
                    <span className="stat-label">Productos Monitoreados</span>
                </div>
                <div className="stat-item">
                    <span className="stat-valor bugs">🔥 {stats?.radarBugs ? stats.radarBugs.length : 8}+ Bugs</span>
                    <span className="stat-label">Gangas Extremas (+70% OFF)</span>
                </div>
                <div className="stat-item">
                    <span className="stat-valor minimos">🏆 {stats?.radarMinimos ? stats.radarMinimos.length : 8}+ Mínimos</span>
                    <span className="stat-label">Récords Históricos</span>
                </div>
                <div className="stat-item">
                    <span className="stat-valor" style={{ color: '#0969da' }}>
                        {ultimaEjecucion ? formatearFecha(ultimaEjecucion) : '⚡ < 50 ms'}
                    </span>
                    <span className="stat-label">Última Sincronización</span>
                </div>
            </div>

            {/* --- RADAR DE OPORTUNIDADES EN TIEMPO REAL --- */}
            {stats && (stats.radarBugs?.length > 0 || stats.radarMinimos?.length > 0) && (
                <div className="radar-container">
                    <div className="radar-header">
                        <h3>🔥 Radar de Oportunidades y Récords Recientes</h3>
                        <button 
                            type="button" 
                            onClick={() => setMostrarRadar(!mostrarRadar)} 
                            className="clear-filters-button"
                            style={{ fontSize: '11px', padding: '3px 8px' }}
                        >
                            {mostrarRadar ? 'Ocultar ▲' : 'Ver ▼'}
                        </button>
                    </div>
                    {mostrarRadar && (
                        <div className="radar-scroll">
                            {(stats.radarBugs || []).concat(stats.radarMinimos || []).slice(0, 10).map((r, idx) => (
                                <div key={r._id || idx} className="radar-card" onClick={() => abrirDetalle(r)}>
                                    <img 
                                        src={r.imagenUrl} 
                                        alt={r.nombre} 
                                        className="radar-card-img" 
                                        onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/200x200/e1e1e1/777?text=Sin+Imagen"; }} 
                                    />
                                    <div className="radar-card-title" title={r.nombre}>{r.nombre}</div>
                                    <div className="radar-card-precios">
                                        <span className="radar-card-price">{formatearMoneda(r.price)}</span>
                                        {r.UltPrecio > r.price && (
                                            <span style={{ fontSize: '11px', textDecoration: 'line-through', color: '#888' }}>
                                                {formatearMoneda(r.UltPrecio)}
                                            </span>
                                        )}
                                    </div>
                                    <div className="radar-card-tienda">
                                        {r.posibleBug ? '🔥 Bug en ' : '🏆 Mínimo en '} {r.tienda}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {/* --- BARRA DE RUBROS / CATEGORÍAS RÁPIDAS --- */}
            <div className="rubros-bar">
                <span className="rubro-label">Rubros:</span>
                {Object.keys(RUBROS).map(rubro => (
                    <button
                        key={rubro}
                        type="button"
                        className={`rubro-btn ${rubroActivo === rubro ? 'active' : ''}`}
                        onClick={() => handleSelectRubro(rubro)}
                    >
                        {rubro}
                    </button>
                ))}
            </div>

            {/* --- SECCIÓN DE FILTROS --- */}
            <div className="filtros">
                {/* --- FILA 1: Selectores principales --- */}
                <div className="filter-row filter-row-inputs">
                    <Select
                        options={tiendasDisponibles}
                        isMulti
                        placeholder="Seleccionar tiendas..."
                        value={tiendasSeleccionadas}
                        onChange={(selected) => { setTiendasSeleccionadas(selected); setRubroActivo('Personalizado'); setPage(1); }}
                        className="select-multi"
                        classNamePrefix="react-select"
                    />
                    <select value={ordenSeleccionado} onChange={e => { setOrdenSeleccionado(e.target.value); setPage(1); }}>
                        <option value="reciente">Más recientes</option>
                        <option value="price_asc">Precio: Menor a Mayor</option>
                        <option value="price_desc">Precio: Mayor a Menor</option>
                        <option value="descuento">% Descuento</option>
                    </select>
                </div>

                {/* --- FILA 2: Búsqueda y Filtros Numéricos --- */}
                <div className="filter-row filter-row-inputs">
                    <input
                        type="text"
                        className="search-input"
                        value={busqueda}
                        onChange={e => { setBusqueda(e.target.value); setPage(1); }}
                        placeholder="Buscar producto..."
                    />
                    <input
                        type="number"
                        value={precioMin}
                        onChange={e => { setPrecioMin(e.target.value); setPage(1); }}
                        placeholder="Precio Mín."
                        min="0"
                    />
                    <input
                        type="number"
                        value={precioMax}
                        onChange={e => { setPrecioMax(e.target.value); setPage(1); }}
                        placeholder="Precio Máx."
                        min="0"
                    />
                    <input
                        type="number"
                        value={horasCambio}
                        onChange={e => { setHorasCambio(e.target.value); setPage(1); }}
                        placeholder="⏱️ Horas (ej: 1)"
                        min="1"
                        title="Mostrar productos actualizados en las últimas N horas"
                    />
                    <input
                        type="text"
                        value={talleBusqueda}
                        onChange={e => { setTalleBusqueda(e.target.value); setPage(1); }}
                        placeholder="👟 Talle (ej: 38, 40, M)"
                        title="Filtrar por talle o número disponible (ej: 37.5, 38, 40, M, L)"
                        style={{ minWidth: '135px' }}
                    />
                </div>

                {/* --- FILA 3: Checkboxes y Botones de Acción --- */}
                <div className="filter-row filter-row-inputs">
                    <label>
                        <input type="checkbox" checked={soloPromos} onChange={e => { setSoloPromos(e.target.checked); setPage(1); }} />
                        Solo promos
                    </label>
                    <label>
                        <input type="checkbox" checked={soloDescuento} onChange={e => { setSoloDescuento(e.target.checked); setPage(1); }} />
                        Solo descuento
                    </label>
                    <label title="Tildar para ver productos pausados o sin stock">
                        <input type="checkbox" checked={mostrarInactivos} onChange={e => { setMostrarInactivos(e.target.checked); setPage(1); }} />
                        Mostrar sin stock / inactivos
                    </label>
                    <label className="checkbox-destacado" title="Detecta ofertas extremas o posibles errores de precio (+70% OFF)">
                        <input type="checkbox" checked={soloBugs} onChange={e => { setSoloBugs(e.target.checked); setPage(1); }} />
                        🔥 Posibles Bugs / Chollos
                    </label>
                    <label className="checkbox-destacado" title="Muestra productos en su precio más bajo histórico registrado">
                        <input type="checkbox" checked={soloMinimoHistorico} onChange={e => { setSoloMinimoHistorico(e.target.checked); setPage(1); }} />
                        🏆 Mínimo Histórico
                    </label>
                    <button onClick={handleClearFilters} className="clear-filters-button">
                        Limpiar filtros
                    </button>
                    <button 
                        type="button" 
                        onClick={() => { setBusqueda("Adidas"); setPage(1); }} 
                        className="clear-filters-button"
                        style={{ backgroundColor: "#111", color: "#fff", border: "1px solid #444" }}
                        title="Filtrar ofertas de Adidas en todas las tiendas de deportes"
                    >
                        👟 Ver Adidas
                    </button>
                    <button 
                        type="button" 
                        onClick={handleRefreshDabra} 
                        className="clear-filters-button"
                        style={{ backgroundColor: "#e65100", color: "#fff", border: "1px solid #bf360c" }}
                        disabled={refrescandoDabra}
                        title="Refrescar catálogo de Grupo Dabra (Dexter, Stock Center, Moov)"
                    >
                        {refrescandoDabra ? "⏳ Refrescando..." : "👟 Refrescar Dabra"}
                    </button>
                    <button 
                        type="button" 
                        onClick={handleRefreshShopify} 
                        className="clear-filters-button"
                        style={{ backgroundColor: "#008060", color: "#fff", border: "1px solid #005640" }}
                        disabled={refrescandoShopify}
                        title="Refrescar catálogo de Shopify (Reebok, Salomon, etc.)"
                    >
                        {refrescandoShopify ? "⏳ Refrescando..." : "🔄 Refrescar Shopify"}
                    </button>
                </div>
            </div>
            
            <div className="view-switcher">
                <button
                    className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`}
                    onClick={() => setViewMode('grid')}
                    aria-label="Vista de grilla"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z"/></svg>
                </button>
                <button
                    className={`view-btn ${viewMode === 'list' ? 'active' : ''}`}
                    onClick={() => setViewMode('list')}
                    aria-label="Vista de lista"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/></svg>
                </button>
            </div>

            {cargando && <div className="loading-indicator">Cargando productos...</div>}
            {errorApi && <div className="error-message">{errorApi}</div>}

            <div className={`productos ${viewMode}`}>
                {productos.map((p, i) => {
                    const cambioPrecio = calcularCambioPrecio(p.price, p.UltPrecio);
                    return (
                        <div
                            key={p._id || i}
                            className="producto"
                            onMouseEnter={(e) => manejarMouseEnter(i, e)}
                            onMouseLeave={manejarMouseLeave}
                            onMouseMove={manejarMouseMove}
                        >
                            <div className="producto-imagen">
                                <img 
                                    src={p.imagenUrl} 
                                    alt={p.nombre} 
                                    onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/300x300/e1e1e1/777?text=Sin+Imagen"; }} 
                                />
                                {p.posibleBug && (
                                    <div className="badge-posible-bug" title="Posible error de precio o liquidación agresiva">
                                        🔥 BUG / GANGA
                                    </div>
                                )}
                                {p.esMinimoHistorico && (
                                    <div className="badge-minimo-historico" title="¡Precio más bajo jamás registrado!">
                                        🏆 MÍNIMO
                                    </div>
                                )}
                                {cambioPrecio.tipo === 'descuento' && (
                                    <div className="descuento-badge">-{cambioPrecio.porcentaje}%</div>
                                )}
                                {cambioPrecio.tipo === 'aumento' && (
                                    <div className="aumento-badge">+{cambioPrecio.porcentaje}%</div>
                                )}
                            </div>
                            
                            <div className="producto-info">
                                <h3>{p.nombre}</h3>
                                <div className="precios">
                                    <p className="precio-actual" style={{color: cambioPrecio.tipo === 'descuento' ? '#28a745' : cambioPrecio.tipo === 'aumento' ? '#dc3545' : 'inherit'}}>
                                        {formatearMoneda(p.price)}
                                    </p>
                                    {p.UltPrecio > 0 && p.price !== p.UltPrecio && (
                                        <p className={`precio-anterior ${cambioPrecio.tipo === 'descuento' ? 'precio-tachado' : ''}`}>
                                            Antes: {formatearMoneda(p.UltPrecio)}
                                        </p>
                                    )}
                                </div>
                                <p className="tienda">
                                    🛍️ {p.tienda}
                                    {p.activo === false && (
                                        <span style={{ backgroundColor: '#ffebee', color: '#c62828', border: '1px solid #ef9a9a', padding: '1px 6px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold', marginLeft: '8px' }}>
                                            ✖ Sin stock
                                        </span>
                                    )}
                                </p>
                                {p.talles && p.talles.length > 0 && (
                                    <div style={{ margin: '3px 0 6px 0', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px' }}>
                                        <span style={{ fontSize: '11px', color: '#666', fontWeight: 'bold' }}>
                                            {/remera|buzo|campera|short|pantalon|calza|musculosa|conjunto|vestido/i.test(p.nombre || '') ? '👕 Talles:' : '👟 Talles:'}
                                        </span>
                                        {p.talles.slice(0, 6).map((t, idx) => (
                                            <span key={idx} style={{ 
                                                backgroundColor: '#e8f0fe', 
                                                color: '#1a73e8', 
                                                border: '1px solid #c2e7ff', 
                                                padding: '1px 5px', 
                                                borderRadius: '3px', 
                                                fontSize: '11px', 
                                                fontWeight: '600' 
                                            }}>
                                                {t}
                                            </span>
                                        ))}
                                        {p.talles.length > 6 && (
                                            <span style={{ fontSize: '11px', color: '#888', fontWeight: '500' }}>
                                                +{p.talles.length - 6}
                                            </span>
                                        )}
                                    </div>
                                )}
                                {p.promotions?.length > 0 ? (
                                    <p className="promos">🎁 {p.promotions.map(promo => promo.name).join(' | ')}</p>
                                ) : (
                                    <p className="promos">Sin promociones</p>
                                )}
                            </div>

                            <div className="producto-accion">
                                <div style={{ display: 'flex', gap: '6px', width: '100%' }}>
                                    <button 
                                        type="button" 
                                        className="btn-ver-producto"
                                        onClick={() => abrirDetalle(p)}
                                        title="Ver información completa, stock y comparaciones con otras tiendas"
                                        style={{ flex: 1 }}
                                    >
                                        👁️ Ver
                                    </button>
                                    <a 
                                        href={p.url} 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="btn-ir-vendedor"
                                        title="Abrir directamente en la web del vendedor"
                                        style={{ flex: '0 0 50px', textAlign: 'center' }}
                                    >
                                        IR ↗
                                    </a>
                                </div>
                                <button
                                    type="button"
                                    className="btn-comparar-card"
                                    onClick={(e) => abrirComparacionModal(e, p)}
                                    title="Comparar el precio de este producto en otras tiendas"
                                >
                                    🔍 Comparar tiendas
                                </button>
                                <button
                                    type="button"
                                    className="btn-copiar-card"
                                    onClick={(e) => handleCopiarOferta(e, p)}
                                    title="Copiar texto de oferta con enlace para compartir"
                                >
                                    {toastCopiado === (p._id || p.sku) ? "✅ ¡Copiado!" : "📋 Copiar Oferta"}
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>

            {tooltipVisible !== null && productos[tooltipVisible]?.precioHistorico && (
              <div
                className="tooltip"
                style={{
                  position: 'fixed',
                  left: tooltipPosition.x,
                  top: Math.min(tooltipPosition.y, (window.innerHeight || 800) - 340),
                  zIndex: 1000,
                  backgroundColor: '#222',
                  border: '1px solid #444',
                  color: 'white',
                  padding: '12px',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
                  maxWidth: '320px',
                  maxHeight: '300px',
                  overflowY: 'auto',
                  fontSize: '12px'
                }}
              >
                <h4 style={{ margin: '0 0 8px 0', color: '#ffd700', fontSize: '13px', display: 'flex', justifyContent: 'space-between' }}>
                  <span>📈 Historial de Precios</span>
                  <span style={{ fontSize: '10px', color: '#aaa', fontWeight: 'normal' }}>Recientes primero</span>
                </h4>
                {[...(productos[tooltipVisible].precioHistorico || [])]
                  .reverse()
                  .map((historial, idx) => (
                  <div key={idx} style={{ marginBottom: '6px', padding: '4px 0', borderBottom: idx < productos[tooltipVisible].precioHistorico.length - 1 ? '1px solid #333' : 'none' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontWeight: 'bold', color: '#fff' }}>{formatearMoneda(historial.precio)}</span>
                      <span style={{ color: '#bbb', fontSize: '11px' }}>{formatearFecha(historial.fecha)}</span>
                    </div>
                    {typeof historial.descuento === 'number' && !isNaN(historial.descuento) && historial.descuento !== 0 && (
                      <div
                        style={{
                          color: historial.descuento > 0 ? '#4ade80' : '#f87171',
                          fontSize: '11px',
                          marginTop: '2px',
                          fontWeight: '500'
                        }}
                      >
                        {historial.descuento > 0
                          ? `Descuento: -${historial.descuento.toFixed(2)}%`
                          : `Aumento: +${Math.abs(historial.descuento).toFixed(2)}%`}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
            
            <div className="paginacion">
                <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1 || cargando}>⬅ Anterior</button>
                <span>Página {page}</span>
                <button onClick={() => setPage(p => p + 1)} disabled={productos.length < 100 || cargando}>Siguiente ➡</button>
            </div>

            {/* --- MODAL RÁPIDO DE COMPARACIÓN MULTITIENDA --- */}
            {comparandoProducto && (
                <div className="modal-backdrop" onClick={cerrarComparacionModal}>
                    <div className="modal-contenido" onClick={e => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>🔍 Comparación de Precios Multitienda</h3>
                            <button className="btn-cerrar-modal" onClick={cerrarComparacionModal}>✕</button>
                        </div>
                        <div className="modal-body">
                            <div className="modal-prod-principal">
                                <img 
                                    src={comparandoProducto.imagenUrl} 
                                    alt={comparandoProducto.nombre} 
                                    onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/100x100/e1e1e1/777?text=Sin+Imagen"; }} 
                                />
                                <div>
                                    <h4 style={{ margin: '0 0 6px 0', fontSize: '14px' }}>{comparandoProducto.nombre}</h4>
                                    <div style={{ fontWeight: 'bold', color: '#16a34a', fontSize: '16px' }}>
                                        {formatearMoneda(comparandoProducto.price)}{' '}
                                        <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 'normal' }}>
                                            ({comparandoProducto.tienda})
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <h4 style={{ margin: '0 0 10px 0', fontSize: '13px', color: '#64748b' }}>
                                Precios detectados en otras tiendas:
                            </h4>
                            
                            {cargandoComparaciones ? (
                                <div style={{ textAlign: 'center', padding: '24px', color: '#64748b' }}>
                                    ⏳ Analizando catálogo en más de 88 tiendas...
                                </div>
                            ) : comparacionesModal.length === 0 ? (
                                <div style={{ textAlign: 'center', padding: '20px', background: darkMode ? '#0d1117' : '#f8fafc', borderRadius: '8px', color: '#64748b', fontSize: '13px' }}>
                                    No se encontraron publicaciones idénticas de este producto en otras tiendas en este momento.
                                </div>
                            ) : (
                                <div className="comparaciones-lista">
                                    {comparacionesModal.map((c, idx) => (
                                        <div key={c._id || idx} className="comparacion-item-modal">
                                            <div>
                                                <div style={{ fontWeight: '600', fontSize: '13px' }}>🛍️ {c.tienda}</div>
                                                <div style={{ fontSize: '11px', color: '#64748b' }}>{c.coincidencia}</div>
                                            </div>
                                            <div style={{ textAlign: 'right', display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                <div>
                                                    <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{formatearMoneda(c.price)}</div>
                                                    {c.diferenciaPrecio !== 0 && (
                                                        <div style={{ fontSize: '11px', color: c.diferenciaPrecio < 0 ? '#16a34a' : '#dc2626' }}>
                                                            {c.diferenciaPrecio < 0 ? `-${Math.abs(c.porcentajeDiferencia)}% más barato` : `+${c.porcentajeDiferencia}% más caro`}
                                                        </div>
                                                    )}
                                                </div>
                                                <a href={c.url} target="_blank" rel="noopener noreferrer" className="btn-ir-comp">
                                                    IR ↗
                                                </a>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            {/* Modal de Simulación de Consola / Terminal Blessed en Vivo */}
            {mostrarConsola && (
                <ConsolaModal 
                    alCerrar={() => setMostrarConsola(false)} 
                    apiBaseUrl={API_BASE_URL}
                />
            )}

            {/* Botón Flotante Rápido de Consola para Móvil y Desktop */}
            <button
                type="button"
                onClick={() => setMostrarConsola(true)}
                className="btn-flotante-consola"
                title="Abrir Consola del Bot en Vivo"
            >
                🖥️ Consola
            </button>
            
        </div>
    );
}

export default App;
